import AbstractFieldsValidator from 'components/helpers/validation/AbstractFieldsValidator';
import validateEmail from 'components/helpers/validation/validateEmail';

export default function (fields, options) {
    return new ForgotPasswordFieldsValidator(fields, options).validate();
}

class ForgotPasswordFieldsValidator extends AbstractFieldsValidator {
    doCheckForSingleValue() {
        const {email} = this.fields;

        if (!email.trim()) this.addError('email', 'Please enter email');

        if (!validateEmail(email)) this.addError('email', 'Please enter a valid email');
    }
}



// WEBPACK FOOTER //
// ./src/components/Auth/ForgotPassword/validateForgotPassword.js